// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VGGtGQ0UUlzB4C {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.VGGtGQ0UUlzB4C > .header-banner,\n.VGGtGQ0UUlzB4C > #header {\n  flex: none;\n}\n.VGGtGQ0UUlzB4C #content {\n  flex-grow: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"surface": "VGGtGQ0UUlzB4C"
};
export default ___CSS_LOADER_EXPORT___;
